/******************************************************************************************
 *	Supported Browser Decider
 *******************************************************************************************
 *
 * Service that contains constants to help determine browser support.
 *
 */
(function() {


  angular.module('rcServices.browserSupported', []).constant(
    'IS_IE11_BROWSER',
    (function() {
      const userAgentContainsMSIE = new RegExp('MSIE');
      const appVersionContainsTrident = new RegExp('Trident/');
      const winNav = window.navigator;

      return (winNav && winNav.userAgent && userAgentContainsMSIE.test(winNav.userAgent)) || (winNav && winNav.appVersion && appVersionContainsTrident.test(winNav.appVersion));
    })()
  );
})();
